var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPropertyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_10761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8 4.15V3.1C13.8 1.945 12.765 1 11.5 1H6.9C5.635 1 4.6 1.945 4.6 3.1V4.15C2.07 4.15 0 6.04 0 8.35V19.9C0 21.055 1.035 22 2.3 22H15.18L12.42 19.48C11.73 18.955 11.385 18.115 11.385 17.38V15.7H5.75V17.8H4.6V15.7H2.3V14.65H11.5V14.44C11.5 12.865 12.88 11.5 14.72 11.5H18.4V8.35C18.4 6.04 16.33 4.15 13.8 4.15ZM9.2 12.55L6.9 10.45L9.2 8.35L11.5 10.45L9.2 12.55ZM11.5 4.15H6.9V3.1H11.5V4.15ZM22.77 17.59L18.63 13.81C18.4 13.705 18.17 13.6 17.94 13.6H14.72C14.26 13.6 13.8 14.02 13.8 14.44V17.38C13.8 17.59 13.915 17.8 14.03 18.01L18.17 21.79C18.285 21.895 18.515 22 18.86 22C19.09 22 19.32 21.895 19.55 21.79L22.77 18.85C22.885 18.745 23 18.535 23 18.22C23 18.01 22.885 17.8 22.77 17.59ZM15.41 15.7C15.065 15.7 14.72 15.385 14.72 15.07C14.72 14.755 15.065 14.44 15.41 14.44C15.755 14.44 16.1 14.755 16.1 15.07C16.1 15.385 15.755 15.7 15.41 15.7Z",
    fill: "#2E8056"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_10761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIcon);
export default __webpack_public_path__ + "static/media/propertyIcon.1afc8bbf17375799633b809d872f91b9.svg";
export { ForwardRef as ReactComponent };